/*
  groomsmen.js — configurator behaviour for the Groomsmen product page.
  Listens to: knife radio change, qty +/- buttons, qty input, engraving inputs.
  Computes: tier discount (1-3 = 0%, 4-5 = 15%, 6+ = 20%), subtotal.
  On Add to Cart: posts N x line items (one per knife) with line item
  properties for engraving, then redirects to /cart.
*/
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.from((r || document).querySelectorAll(s)); }

  function tierFor(qty) {
    if (qty >= 6) return 0.20;
    if (qty >= 4) return 0.15;
    return 0;
  }

  function fmt(amount) {
    return '$' + amount.toFixed(0).toLocaleString();
  }

  function leadTimeOrderByText() {
    var d = new Date();
    d.setDate(d.getDate() + 12 * 7); // 12 weeks
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  var section = $('.gm');
  if (!section) return;

  var qtyInput = $('#gm-qty');
  var engravingsWrap = $('#gm-engravings');
  var tierBadge = $('#gm-tier');
  var addBtn = $('#gm-add-to-cart');

  // Summary refs
  var sumKnife = $('#gm-summary-knife');
  var sumQty = $('#gm-summary-qty');
  var sumFull = $('#gm-summary-full');
  var sumDiscountRow = $('#gm-summary-discount-row');
  var sumDiscount = $('#gm-summary-discount');
  var sumSubtotal = $('#gm-summary-subtotal');
  var sumCases = $('#gm-summary-cases');
  var sumEngravings = $('#gm-summary-engravings');
  var sumByDate = $('#gm-summary-bydate');

  function getSelectedKnife() {
    var checked = $('input[name="knife"]:checked');
    if (!checked) return null;
    var label = checked.closest('.gm-shape, .gm-knife'); // tolerate either old or new selector
    if (!label) return null;
    var price = parseFloat(label.dataset.variantPrice) || 0;
    return {
      variantId: label.dataset.variantId,
      name: label.dataset.variantName,
      price: price,
    };
  }

  function getQty() {
    var n = parseInt(qtyInput.value, 10) || 1;
    return Math.max(1, Math.min(20, n));
  }

  function renderEngravings(qty) {
    var existing = $$('.gm-engraving', engravingsWrap);
    if (existing.length === qty) return; // no rebuild needed

    // Save existing values
    var values = existing.map(function (row) {
      var date = $('input[data-field="date"]', row);
      var initials = $('input[data-field="initials"]', row);
      return { date: date ? date.value : '', initials: initials ? initials.value : '' };
    });

    engravingsWrap.innerHTML = '';
    for (var i = 0; i < qty; i++) {
      var row = document.createElement('div');
      row.className = 'gm-engraving';
      row.innerHTML =
        '<div class="gm-engraving__label">Knife ' + (i + 1) + '</div>' +
        '<input type="text" placeholder="Date (e.g. 12.10.26)" maxlength="12" data-field="date" value="' + (values[i] ? values[i].date : '') + '">' +
        '<input type="text" placeholder="Initials (e.g. J.S.)" maxlength="8" data-field="initials" value="' + (values[i] ? values[i].initials : '') + '">';
      engravingsWrap.appendChild(row);
    }
  }

  function updateSummary() {
    var knife = getSelectedKnife();
    var qty = getQty();
    if (!knife) return;

    var tier = tierFor(qty);
    var priceEach = knife.price;
    var fullSubtotal = priceEach * qty;
    var discountAmount = fullSubtotal * tier;
    var subtotalAfterDiscount = fullSubtotal - discountAmount;

    sumKnife.textContent = knife.name;
    sumQty.textContent = qty;
    sumFull.textContent = fmt(priceEach);
    sumCases.textContent = qty;
    sumEngravings.textContent = qty;

    if (tier > 0) {
      sumDiscountRow.hidden = false;
      sumDiscount.textContent = '−' + fmt(discountAmount) + ' (' + Math.round(tier * 100) + '% off)';
    } else {
      sumDiscountRow.hidden = true;
    }
    sumSubtotal.textContent = fmt(subtotalAfterDiscount);
    sumByDate.textContent = leadTimeOrderByText();

    // Mobile sticky bar mirror
    var mobileBarAmount = $('#gm-mobile-bar-amount');
    if (mobileBarAmount) mobileBarAmount.textContent = fmt(subtotalAfterDiscount);

    // Tier hint message
    var hint = '';
    if (qty < 4) {
      hint = 'Add ' + (4 - qty) + ' more knife' + (4 - qty === 1 ? '' : 's') + ' to unlock 15% off.';
    } else if (qty < 6) {
      var saved = fmt(discountAmount);
      hint = 'Saving ' + saved + ' (15% off). Add ' + (6 - qty) + ' more for 20% off.';
    } else {
      hint = 'Saving ' + fmt(discountAmount) + ' (20% off). Maximum tier unlocked.';
    }
    tierBadge.textContent = hint;
  }

  // ============ Gallery ============
  var galleryImg = $('#gm-gallery-image');
  var galleryThumbs = $('#gm-gallery-thumbs');
  var galleryCounter = $('#gm-gallery-counter');
  var galleryPrev = $('.gm-gallery__nav--prev');
  var galleryNext = $('.gm-gallery__nav--next');

  var variantImagesMap = {};
  try {
    var dataNode = $('#gm-variant-images');
    if (dataNode) {
      var raw = dataNode.textContent.trim();
      // Defensive: strip trailing commas before ] or } (Liquid sometimes leaves these)
      var sanitized = raw.replace(/,(\s*[\]}])/g, '$1');
      variantImagesMap = JSON.parse(sanitized);
    }
  } catch (e) {
    console.warn('[gm] failed to parse variant images JSON:', e);
  }

  var galleryState = { variantId: null, images: [], index: 0 };

  function setGalleryVariant(variantId) {
    var images = variantImagesMap[variantId] || [];
    galleryState.variantId = variantId;
    galleryState.images = images;
    galleryState.index = 0;
    renderGallery();
  }

  function renderGallery() {
    if (!galleryImg) return;
    if (!galleryState.images.length) {
      galleryImg.removeAttribute('src');
      galleryImg.alt = '';
      galleryThumbs.innerHTML = '';
      galleryCounter.textContent = '';
      return;
    }
    galleryImg.classList.add('is-loading');
    var url = galleryState.images[galleryState.index];
    var preload = new Image();
    preload.onload = function () {
      galleryImg.src = url;
      galleryImg.classList.remove('is-loading');
    };
    preload.onerror = function () {
      galleryImg.classList.remove('is-loading');
    };
    preload.src = url;
    galleryImg.alt = (getSelectedKnife() || {}).name || '';
    galleryCounter.textContent = (galleryState.index + 1) + ' / ' + galleryState.images.length;

    galleryThumbs.innerHTML = '';
    galleryState.images.forEach(function (src, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gm-gallery__thumb' + (i === galleryState.index ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === galleryState.index ? 'true' : 'false');
      btn.addEventListener('click', function () {
        galleryState.index = i;
        renderGallery();
      });
      var img = document.createElement('img');
      img.src = src;
      img.loading = 'lazy';
      img.alt = '';
      btn.appendChild(img);
      galleryThumbs.appendChild(btn);
    });
  }

  if (galleryPrev) {
    galleryPrev.addEventListener('click', function () {
      if (!galleryState.images.length) return;
      galleryState.index = (galleryState.index - 1 + galleryState.images.length) % galleryState.images.length;
      renderGallery();
    });
  }
  if (galleryNext) {
    galleryNext.addEventListener('click', function () {
      if (!galleryState.images.length) return;
      galleryState.index = (galleryState.index + 1) % galleryState.images.length;
      renderGallery();
    });
  }

  // Touch/swipe on the main image (mobile)
  if (galleryImg) {
    var touchStartX = 0;
    galleryImg.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryImg.addEventListener('touchend', function (e) {
      var dx = (e.changedTouches[0].clientX) - touchStartX;
      if (Math.abs(dx) < 40) return;
      galleryState.index = (galleryState.index + (dx < 0 ? 1 : -1) + galleryState.images.length) % galleryState.images.length;
      renderGallery();
    });
  }

  // ============ Event listeners ============
  $$('input[name="knife"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      $$('.gm-shape, .gm-knife').forEach(function (n) { n.classList.remove('is-selected'); });
      var label = radio.closest('.gm-shape, .gm-knife');
      if (label) label.classList.add('is-selected');
      setGalleryVariant(radio.value);
      updateSummary();
    });
  });

  $$('.gm-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = btn.dataset.action === 'increment' ? 1 : -1;
      var next = Math.max(1, Math.min(20, getQty() + step));
      qtyInput.value = next;
      renderEngravings(next);
      updateSummary();
    });
  });

  qtyInput.addEventListener('input', function () {
    var n = getQty();
    qtyInput.value = n;
    renderEngravings(n);
    updateSummary();
  });

  // ============ Add to cart ============
  function handleAddToCart() {
    var knife = getSelectedKnife();
    if (!knife) {
      alert('Please choose a knife shape.');
      return;
    }
    var qty = getQty();
    var rows = $$('.gm-engraving');
    var missing = false;

    var lineItems = [];
    rows.forEach(function (row, i) {
      var date = $('input[data-field="date"]', row).value.trim();
      var initials = $('input[data-field="initials"]', row).value.trim();
      if (!date || !initials) missing = true;
      lineItems.push({
        id: parseInt(knife.variantId, 10),
        quantity: 1,
        properties: {
          'Engraving — Date': date,
          'Engraving — Initials': initials,
          'Set member': (i + 1) + ' of ' + qty,
          'Leather case': 'Included free',
        }
      });
    });

    if (missing) {
      var ok = confirm('Some engraving fields are empty. Submit anyway and reply to your confirmation email with the engraving text?');
      if (!ok) return;
    }

    addBtn.disabled = true;
    addBtn.textContent = 'Adding to cart…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        alert('Could not add to cart. Please try again, or email izac@irongateknives.com.\n\n' + err.message);
      });
  }
  addBtn.addEventListener('click', handleAddToCart);
  var mobileCta = $('#gm-mobile-bar-cta');
  if (mobileCta) mobileCta.addEventListener('click', handleAddToCart);

  // ============ init ============
  renderEngravings(getQty());
  updateSummary();
  var initial = getSelectedKnife();
  if (initial) setGalleryVariant(initial.variantId);
})();
